import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  StudyProgramsPage,
  StudyProgramsEdit,
} from '../pages/CMSPages/index';
import React from 'react';

const StudyProgramsRoutes = () => (
  <>
    <Route
      path={`${routes.cmsStudyPrograms}`}
      element={
        <CMSWrapper permissions={['study-programs.index']}>
          <StudyProgramsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsStudyProgramsCreate}`}
      element={
        <CMSWrapper permissions={['study-programs.store']}>
          <StudyProgramsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsStudyProgramsEdit}/:id`}
      element={
        <CMSWrapper permissions={['study-programs.update']}>
          <StudyProgramsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
  </>
);

export default StudyProgramsRoutes;
